import { mensagemPadrao } from 'src/dados-estaticos'
import * as Yup from 'yup'
const caracter = Yup.string().required(mensagemPadrao)
const codigoSegurancaMensagem = 'CVV inválido'

export const schemaCartao = Yup.object().shape({
  formaPagamento: caracter,
  parcelas: caracter,
  numeroCartao: Yup.string().cartaoCredito().required(mensagemPadrao),
  nomeCartao: caracter,
  validadeCartao: Yup.string().validadeCartaoCredito().required(mensagemPadrao),
  codigoSeguranca: Yup.string()
    .nullable()
    .min(3, codigoSegurancaMensagem)
    .max(4, codigoSegurancaMensagem)
    .required(mensagemPadrao)
})

export const schemaBoleto = Yup.object().shape({
  formaPagamento: caracter
})
